export default __webpack_public_path__ + "static/media/snare.3aa3f943.wav";